import { AddDriverCard } from '@/modules/users/UserProfile/AddDriverCard'
import { isDriverCardExpired } from '@/modules/users/util'
import React from 'react'
import { useUser } from '@/utils/hooks'

interface DashboardDriverCardProps {}

export const DashboardDriverCard: React.FC<DashboardDriverCardProps> = () => {
  const user = useUser()

  if (user.activeDriverCard && !isDriverCardExpired(user.activeDriverCard))
    return null

  return <AddDriverCard user={user} />
}
